const localizers = {
  'loading.msg': () => `Načítava sa...`,
  'logon.message.msg': () => `Vyžaduje sa overenie. Zadajte platný identifikátor a heslo používateľa.`,
  'logon.button.msg': () => `Prihlásenie...`,
  'SASServer.logonError.msg': () => `Nedá sa prihlásiť na server.`,
  'SASServer.genericError.msg': () => `Nedá sa spojiť so serverom.`,
}
export default localizers;
